import React from 'react';
import { getScriptSureInvitationLink } from 'api/textVisit';

let globalData: string = '';

const useGetScriptSureOnboardLink = (): [string, boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<string>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getScriptSureInvitationLink();
            if (!result.error) {
                const data: string = result?.data?.data;
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [items, loading.current, fetchData];
};

export default useGetScriptSureOnboardLink;
